import { useState } from "react"
import { SystemSS } from "../../../components/SystemSS"
import { FullScreenModal } from "../../../utility/FullScreenModal"

export const FacilitiesFusion = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
        console.log('clickd')
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    return (
        <>
            <section className=''>
                <div className='flex justify-center '>
                    <img
                        className=''
                        alt='confine'
                        src={`${process.env.PUBLIC_URL}/images/system/system-fusion-fr.webp`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                        Vous pouvez <span className='text-pborange'>enforcer un objet</span> en le synthétisant à l'aide
                        de Mana et de matériaux. Quand vous obtenez une nouvelle arme et que vous n'avez plus besoin de
                        celle que vous utilisiez jusqu'alors, utilisez Synthèse. Les PV et autres statistiques de la
                        nouvelle arme seront
                        <span className='text-pborange'> augmentés</span>, et vous pourrez utiliser cette version
                        améliorée au combat.
                    </p>{' '}
                    <br />
                    <p>Vous pouvez également convertir des objets en Mana pour obtenir le Titre de l'objet !</p>
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'fusion',
                                index: 1,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                        description='Synthétisez vos objets inutilisés pour fabriquer les armes les plus puissantes !'
                    />{' '}
                </div>
            </section>{' '}
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={1}
            />
        </>
    ) 
}
